<template>
  <div>
    <div class="tile is-ancestor">
      <div class="tile is-5 is-vertical notification is-primary home-tile">
        <p class="title">Welcome</p>
        <p class="subtitle">
          Do you see any Teletubbies in here? Do you see a slender plastic tag clipped to my shirt with my name printed on it? No?
        </p>
      </div>
      <div class="tile is-3 is-vertical notification is-info home-tile clickable">
        <router-link to="/categories" tag="div">

        <p class="title">Industries</p>
          <p class="subtitle">Explore hundreds of SaaS software categories and business niches.</p>
        </router-link>

      </div>

      <div class="tile is-3 is-vertical notification is-success home-tile clickable">
        <router-link to="/products" tag="div">

        <p class="title">Software</p>
          <p class="subtitle">Analyze 35k+ products</p>
        </router-link>

      </div>
    </div>
  </div>
</template>

<script>
import FindProductDropdown from '@/components/FindProductDropdown'
import FindCategoryDropdown from '@/components/FindCategoryDropdown'

export default {
  name: 'Home',
  components: {
    FindProductDropdown,
    FindCategoryDropdown,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.home-tile {
  margin: 10px;
  height:250px;
}

.home-tile.clickable {
  opacity:0.9;
}

.home-tile.clickable:hover {
  opacity:1;
  cursor: pointer;
}

</style>
